import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'fury-edit-plan-type',
  templateUrl: './edit-plan-type.component.html',
  styleUrls: ['./edit-plan-type.component.scss']
})
export class EditPlanTypeComponent implements OnInit {
  
  planTypeForm = new FormGroup({
    planType : new FormControl('', [Validators.required])
  })
  constructor(
    public dialogRef: MatDialogRef<EditPlanTypeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FormGroup
  ) { }

  ngOnInit(): void {
   this.planTypeForm.get('planType').setValue(this.data.value?.planType !== 'PAY FOR 3 YEARS' ? this.data.value?.planType : this.data.value?.signaturePlan);
  }
  close() {
    this.dialogRef.close();
  }

  update() {
    this.dialogRef.close(this.planTypeForm.value?.planType);
  }

}
